import { loadTimeForm } from 'features/daily-plan/utils';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import {
  CandidateEntity,
  CompanyEntity,
  ContactEntity,
  ContactMapByEntityType,
  EntityType
} from 'UI/constants/entityTypes';
import { OptionRenderers } from 'UI/utils/renderers';

import { prepareDateForPicker } from '../shared/DateTimePickers/DateTimePicker.utils';

export const FORM_FIELDS_MAP = {
  TaskId: {
    key: 'id'
  },
  TaskType: {
    key: 'taskType',
    paramKey: 'taskTypeId',
    outboundAccesor: 'id'
  },
  Date: {
    key: 'date',
    inboundAccesor: form => prepareDateForPicker(form)
  },
  Time: {
    key: 'time',
    inboundAccesor: loadTimeForm
  },
  OtherTask: {
    key: 'otherTask',
    paramKey: 'customTask',
    inboundAccesor: 'customTask'
  },
  ReachToEntity: {
    key: 'reachTo',
    inboundAccesor: form => REACH_TO_NAME_INBOUND_KEY_MAP[form.entityType?.code]?.reachTo
  },
  ReachToName: {
    key: 'reachToName',
    outboundAccesor: 'id',
    inboundAccesor: form => {
      const key = REACH_TO_NAME_INBOUND_KEY_MAP[form.entityType?.code]?.entityKey;

      return {
        id: form.entity?.id,
        [key]: form?.entity?.contactName,
        entityType: form.entityType?.code,
        type: form.entityType?.code,
        role_id: ContactMapByEntityType[form.entityType?.code]
      };
    }
  },
  Comments: {
    key: 'comment',
    inboundAccesor: 'lastComment'
  }
};

const REACH_TO_NAME_INBOUND_KEY_MAP = {
  [EntityType.Contact]: {
    entityKey: 'full_name',
    reachTo: EntityType.Contact
  },
  [EntityType.Candidate]: {
    entityKey: 'title',
    reachTo: EntityType.Candidate
  },
  [EntityType.Company]: {
    entityKey: 'name',
    reachTo: EntityType.Company
  },
  [EntityType.HiringAuthority]: {
    entityKey: 'full_name',
    reachTo: EntityType.Contact
  }
};

export const ENTITY_OPTIONS_TO_REACH_OUT = [
  {
    label: ContactEntity.singular,
    value: 'name'
  },
  {
    label: CandidateEntity.singular,
    value: 'candidate'
  },
  {
    label: CompanyEntity.singular,
    value: 'company'
  }
];

export const REACH_OUT_AUTOCOMPLETE_PROPS_BY_ENTITY = {
  candidate: {
    placeholder: strings.dailyPlan.drawer.form.placeholders.selectCandidate,
    url: Endpoints.Search,
    typeaheadParams: { entityType: EntityType.Candidate },
    renderOption: OptionRenderers.globalSearchPerson('title')
  },
  name: {
    placeholder: strings.dailyPlan.drawer.form.placeholders.selectContact,
    url: Endpoints.Search,
    typeaheadParams: { entityType: 'hiringAuthorityOrName' },
    renderOption: OptionRenderers.globalSearchPerson('full_name'),
    displayKey: 'full_name',
    groupBy: option => option.typeTitle
  },
  company: {
    placeholder: strings.dailyPlan.drawer.form.placeholders.selectCompany,
    url: Endpoints.Search,
    typeaheadParams: { entityType: EntityType.Company },
    displayKey: 'name',
    renderOption: OptionRenderers.globalCompanySearch({ displayKey: 'name' })
  }
};
